import type { PortalIdentity } from "@/data/Tastier";
import type { Language } from "@/data/model/Enums";

import { AccountPanel } from "@/portal/ui/AccountPanel";
import { LocationSwitch } from "@/portal/ui/RestaurantSwitch";

export const TastierGlobal = {
    locationSwitch: undefined as LocationSwitch | undefined,
    accountPanel: undefined as AccountPanel | undefined,

    getLocationSwitch() {
        return this.locationSwitch;
    },

    setLocationSwitch($element: JQuery | undefined) {
        this.locationSwitch = new LocationSwitch($element);
    },

    getIdentity(): PortalIdentity | undefined {
        return window.TastierIdentity;
    },

    getLang(): Language {
        return this.getIdentity()!.lang;
    },

    getUserLocale(): string | undefined {
        return this.getIdentity()?.langIso;
    },

    getAccountPanel(): AccountPanel | undefined {
        return this.accountPanel;
    },

    setAccountPanel($element: JQuery) {
        this.accountPanel = new AccountPanel($element);
    },

    // libraries to be moved to imports
    getKTUtil(): any {
        return window["KTUtil"];
    },

    getKTAvatar(params: any): any {
        return new window["KTAvatar"](params);
    },

    getKTDialog(params: any): any {
        return new window["KTDialog"](params);
    },
};
